import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { startOfWeek, endOfWeek, format, parseISO } from 'date-fns';
import './detail.css';
import Sidebar from '../../components/SideBar/Sidebar.js';
import calendarIcon from '../../assets/calendar_today-sm.svg';
import { mostRecentUpcomingEvents } from '../../store/events/actions';
import { GetTimeZone, formatDate } from '../../components/common/DateTimeFormatter';
import { hideLoading, showLoading } from '../../store/loading-reducer';
import PropTypes from 'prop-types';
import { shopMonitorSliderTime } from '../../helpers/enums';
import { useNavigate } from 'react-router-dom';
import { getCompanies, getLoggedInEmployeeById } from '../../store/employee/actions';
import { getEmployeesCompanyList } from '../../api/events';
import Check from "../../assets/check-circle-dark.svg";

const todayEvents = (upcomingEvents) => {
    const today = format(new Date(), "MM/dd/yyyy");
    const todayEventList = [];
    const otherEventList = [];
    upcomingEvents.forEach(event => {
        const eventDate = formatDate(event.eventDate);
        if (eventDate === today) {
            if (todayEventList.length < 12) {
                todayEventList.push(event);
            }
        } else {
            if (otherEventList.length < 12) {
                otherEventList.push(event);
            }
        }
    });

    return { todayEventList, otherEventList };
};
function groupEventsByWeek(events) {
    const weeksMap = new Map();

    events.forEach(event => {
        const eventDate = parseISO(event.eventDate);
        const weekStart = startOfWeek(eventDate, { weekStartsOn: 0 });
        const weekEnd = endOfWeek(eventDate, { weekStartsOn: 0 });

        const sameMonth = weekStart.getMonth() === weekEnd.getMonth();
        let weekLabel = '';

        if (sameMonth) {
            weekLabel = `Week of ${format(weekStart, "MMMM d")}-${format(weekEnd, "d")}`;
        } else {
            weekLabel = `Week of ${format(weekStart, "MMMM d")}-${format(weekEnd, "d MMM")}`;
        }

        if (!weeksMap.has(weekLabel)) {
            weeksMap.set(weekLabel, []);
        }
        weeksMap.get(weekLabel).push(event);
    });

    return Array.from(weeksMap.entries());
}

export default function ShopMonitors({ handleloadinTiming }) {
    const dispatch = useDispatch();
    const { upcomingEvents } = useSelector(state => state.event);
    const [filter, setFilter] = useState({ companyId: 0, userId: 0, sort: 6, timezone: GetTimeZone() });
    const isLoading = useSelector((state) => state.loading);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const companiesList = useSelector(state => state.employee.companiesList);
    const { todayEventList, otherEventList } = todayEvents(upcomingEvents);
    const [employeeCompany, setEmployeeCompany] = useState([]);
    const { siteUserId } = useSelector(state => state.auth);
    const groupedOtherEvents = groupEventsByWeek(otherEventList);
    useEffect(() => {
        document.title = 'Events | CWP Team Connect';
        dispatch(showLoading());
        handleloadinTiming(shopMonitorSliderTime.LeadingTime);
        let sharpCompanyId = localStorage.getItem('monitor_mode_company');
        if (sharpCompanyId !== undefined && sharpCompanyId !== null && sharpCompanyId != '0' && sharpCompanyId != 0) {
            setFilter({ ...filter, companyId: parseInt(sharpCompanyId) });
        }
        else {
            let defaultCompany= companiesList && companiesList.length > 0 ? companiesList[0].id : 0;
            localStorage.setItem('monitor_mode_company', defaultCompany);
            setFilter({ ...filter, companyId: parseInt(defaultCompany) });
        }

    }, []);

    useEffect(() => {
        if (filter.companyId > 0) {
            dispatch(mostRecentUpcomingEvents(filter)).unwrap().then(() => {
                dispatch(hideLoading());
                handleloadinTiming(shopMonitorSliderTime.default);
                setIsDataLoaded(true);
            });
        }
    }, [filter]);


    useEffect(() => {
        if (isLoading && isDataLoaded) {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
        }
    }, [isLoading, isDataLoaded]);

    useEffect(() => {
        document.title = 'Dashboard | CWP Team Connect'
        dispatch(showLoading());
        dispatch(getLoggedInEmployeeById({ id: siteUserId }));
        dispatch(getCompanies());
        getEmployeesCompanyList(siteUserId).then((response) => {
            let employeeCompanyResponse = response.data.data;
            setEmployeeCompany(employeeCompanyResponse);
        });
    }, []);

    const RsvpTypes = {
        NO: 'no',
        YES: 'yes',
        ONE_PLUS: 'oneplus',
    };

    let checkDate = '';
    const hideEventDate = (date) => {
        if (checkDate != date) {
            checkDate = date;
            return true;
        }
        return false;
    }
    const navigate = useNavigate();

    return (
        <div className="monitors-inner">
            <div className="monitors-item">
                <div className="monitors-header-wrap">
                    <p className="monitors-header-title">Events</p>
                    <span className="monitors-header-icon"><img src={calendarIcon} alt="Calendar Icon" /></span>
                </div>
                <div className="monitors-item-event-wrap"> 


                    <div className="event-grid-item-wrap"> 
                        {groupedOtherEvents.map(([weekLabel, events]) => {
                            const weekStart = startOfWeek(parseISO(events[0].eventDate), { weekStartsOn: 0 });
                            const weekEnd = endOfWeek(parseISO(events[0].eventDate), { weekStartsOn: 0 });
                             
                            const todaysEventsInThisWeek = todayEventList.filter(ev => {
                                const date = parseISO(ev.eventDate);
                                return date >= weekStart && date <= weekEnd;
                            });

                            return (
                                    <div key={weekLabel} className="events-listing-wrapping">
                                    <span className="events-month-title-month">{weekLabel}</span>

                                    {todaysEventsInThisWeek.length > 0 && (
                                        <span className="today-span">
                                            <span className="today-title-tab">Today</span>
                                            {todaysEventsInThisWeek.map(log => (
                                                <a onClick={() => navigate('/event-detail/' + log.event?.baseId + '/' + log.id)} className="events-listing-item" key={log.id}>
                                                    <div className="events-date-wrap">
                                                        {hideEventDate(formatDate(log?.eventDate, "MMM d")) && (
                                                            <div className="events-date-wrap-inner">
                                                                {new Date(log.eventDate).getMonth() !== new Date().getMonth() && (
                                                                    <span className="events-month-title-month">{formatDate(log.eventDate, "MMMM")}</span>
                                                                )}
                                                                <span className="events-month-title">{formatDate(log.eventDate, "EEE")}</span>
                                                                <span className="events-day-title">{formatDate(log.eventDate, "d")}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="events-title-wrap">
                                                        <div className="events-title-inner">
                                                            <p className="flex-wraping">
                                                                <span>{log.event?.title}</span>
                                                            </p>
                                                            <div className="events-rsvp-wrap">
                                                                <p>{log?.startTime}</p>
                                                                {log.event.eventCompanies && log.event.eventCompanies.length > 0 && log.event.eventCompanies.some(company => employeeCompany.find(empCompany => empCompany.id === company.companyId)) && (
                                                                    log.event && (log.event.rsvpType === RsvpTypes.YES || log.event.rsvpType === RsvpTypes.ONE_PLUS) && (
                                                                        <>
                                                                            {(log.event?.eventRSVPs?.siteUserId !== siteUserId || (log.event?.eventRSVPs?.siteUserId === siteUserId && log.event?.eventRSVPs?.numPlus1s === 0)) && (
                                                                                <button className="events-rsvp-cta">RSVP Here</button>
                                                                            )}
                                                                            {log.event?.eventRSVPs?.siteUserId === siteUserId && log.event?.eventRSVPs?.numPlus1s > 0 && (
                                                                                <p className="dashboard-check-status">
                                                                                    <img src={Check} alt="check" loading="lazy" />
                                                                                    <span>RSVP&#39;d</span>
                                                                                </p>
                                                                            )}
                                                                        </>
                                                                    )
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            ))}
                                        </span>
                                        )}

                                    {events.map(log => (
                                        <a onClick={() => navigate('/event-detail/' + log.event?.baseId + '/' + log.id)} className="events-listing-item" key={log.id}>
                                            <div className="events-date-wrap">
                                                {hideEventDate(formatDate(log?.eventDate, "MMM d")) && (
                                                    <div className="events-date-wrap-inner">
                                                        <span className="events-month-title">{formatDate(log.eventDate, "EEE")}</span>
                                                        <span className="events-day-title">{formatDate(log.eventDate, "d")}</span>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="events-title-wrap">
                                                <div className="events-title-inner">
                                                    <p className="flex-wraping">
                                                        <span>{log.event?.title}</span>
                                                    </p>
                                                    <div className="events-rsvp-wrap">
                                                        <p>{log?.startTime}</p>
                                                        {log.event.eventCompanies && log.event.eventCompanies.length > 0 && log.event.eventCompanies.some(company => employeeCompany.find(empCompany => empCompany.id === company.companyId)) && (
                                                            log.event && (log.event.rsvpType === RsvpTypes.YES || log.event.rsvpType === RsvpTypes.ONE_PLUS) && (
                                                                <>
                                                                    {(log.event?.eventRSVPs?.siteUserId !== siteUserId || (log.event?.eventRSVPs?.siteUserId === siteUserId && log.event?.eventRSVPs?.numPlus1s === 0)) && (
                                                                        <button className="events-rsvp-cta">RSVP Here</button>
                                                                    )}
                                                                    {log.event?.eventRSVPs?.siteUserId === siteUserId && log.event?.eventRSVPs?.numPlus1s > 0 && (
                                                                        <p className="dashboard-check-status">
                                                                            <img src={Check} alt="check" loading="lazy" />
                                                                            <span>RSVP&#39;d</span>
                                                                        </p>
                                                                    )}
                                                                </>
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    ))}
                                    </div>
                               
                            );
                        })}
                    </div>
                </div>
            </div>
            <Sidebar
                pageType={"events"}
            />
        </div>
    );
}

ShopMonitors.propTypes = {
    handleloadinTiming: PropTypes.func
};